import React, { useEffect, useState } from "react";
import "./app-downloads.scss";
import WebBrowserImage from "../../assets/images/downloads/web-browser.svg";
import AppleLogo from "../../assets/images/downloads/apple-logo.svg";
import WindowsLogo from "../../assets/images/downloads/windows-logo.svg";
import ChromeLogo from "../../assets/images/downloads/chrome-logo.svg";
import EdgeLogo from "../../assets/images/downloads/edge-logo.svg";
import { Button } from "droplr-react-ui-v2";

export const AppDownloadsComponent = (): JSX.Element => {
  const LINKS = {
    DASHBOARD: process.env.REACT_APP_DASHBOARD_URL,
    MACOS_INTEL: "https://files.droplr.com/apps/mac-intel-current",
    MACOS_APPLE_SILLICON: "https://files.droplr.com/apps/mac-m1-current",
    WINDOWS: "https://files.droplr.com/apps/windows-current",
    CHROME_EXTENSION:
      "https://chrome.google.com/webstore/detail/oncaapliomaamlbopdmhmdompfemljhm",
  };
  const [UserAgent, setUserAgent] = useState("");
  const [BrowserAgent, setBrowserAgent] = useState("");
  const [JwtToken, setJwtToken] = useState<any>(null);
  const [AccessToken, setAccessToken] = useState<any>(null);

  /**
   * Fetch the user agent to display varying download options
   */
  useEffect(() => {
    const URLParams = new URLSearchParams(window.location.search);
    let JwtToken = URLParams.get("jwtToken");
    let AccessToken = URLParams.get("accessToken");
    if (JwtToken != null) {
      setJwtToken(JwtToken);
    }
    if (AccessToken != null) {
      setAccessToken(AccessToken);
    }
    const navigatorUA = navigator.userAgent;
    if (navigatorUA.includes("Mac OS X")) {
      setUserAgent("mac");
    } else if (navigatorUA.includes("Windows")) {
      setUserAgent("windows");
    } else if (
      navigatorUA.includes("Linux") &&
      !navigatorUA.includes("Android")
    ) {
      setUserAgent("linux");
    } else if (navigatorUA.includes("Android")) {
      setUserAgent("android");
    } else if (navigatorUA.includes("iPhone") || navigatorUA.includes("iPad")) {
      setUserAgent("ios");
    } else {
      setUserAgent("other");
    }

    if (navigator.userAgent.indexOf("Chrome") !== -1) {
      setBrowserAgent("chrome");
    } else if (navigator.userAgent.indexOf("Safari") !== -1) {
      setBrowserAgent("safari");
    } else if (navigator.userAgent.indexOf("Firefox") !== -1) {
      setBrowserAgent("firefox");
    } else if (navigator.userAgent.indexOf("Edge") !== -1) {
      setBrowserAgent("edge");
    } else {
      setBrowserAgent("other");
    }
  }, []);

  const ShowChromeInstall = () =>
    BrowserAgent === "chrome" ||
    UserAgent === "mac" ||
    UserAgent === "android" ||
    UserAgent === "windows";
  const ShowEdgeInstall = () =>
    BrowserAgent === "edge" ||
    UserAgent === "windows" ||
    UserAgent === "android" ||
    BrowserAgent === "chrome";
  const ShowMacInstall = () =>
    UserAgent === "mac" || UserAgent === "ios" || UserAgent === "linux";
  const ShowWindowsInstall = () =>
    UserAgent === "windows" || UserAgent === "linux" || UserAgent === "android";

  return (
    <div className="app-downloads-container">
      <div className="downloads-list late-fade-in">
        <div className="download-option">
          <div className="left-aligned">
            <div className="download-icon">
              <img src={WebBrowserImage} alt="Web Browser" />
            </div>
            <div className="download-text">
              Use your browser <br></br>
              <span>Dashboard</span>
            </div>
          </div>
          <div className="right-aligned">
            <div
              className="download-button"
              onClick={() => {
                window.location.href = `${LINKS.DASHBOARD}/auth?accessToken=${AccessToken}&jwtToken=${JwtToken}`;
              }}
            >
              <Button
                className="download-button"
                label={"Open"}
                variant="primary"
              />
            </div>
          </div>
        </div>
        {ShowMacInstall() && (
          <>
            <div className="download-option">
              <div className="left-aligned">
                <div className="download-icon">
                  <img src={AppleLogo} alt="Web Browser" />
                </div>
                <div className="download-text">
                  Download the native app for <br></br>
                  <span>MacOS (Intel)</span>
                </div>
              </div>
              <div className="right-aligned">
                <Button
                  className="download-button"
                  variant="secondary"
                  onClick={() => {
                    window.open(LINKS.MACOS_INTEL, "_blank");
                  }}
                  label="Download"
                />
              </div>
            </div>
            <div className="download-option">
              <div className="left-aligned">
                <div className="download-icon">
                  <img src={AppleLogo} alt="Web Browser" />
                </div>
                <div className="download-text">
                  Download the native app for <br></br>
                  <span>MacOS (Apple Sillicon)</span>
                </div>
              </div>
              <div className="right-aligned">
                <Button
                  className="download-button"
                  variant="secondary"
                  onClick={() => {
                    window.open(LINKS.MACOS_APPLE_SILLICON, "_blank");
                  }}
                  label="Download"
                />
              </div>
            </div>
          </>
        )}
        {ShowWindowsInstall() && (
          <div className="download-option">
            <div className="left-aligned">
              <div className="download-icon">
                <img src={WindowsLogo} alt="Web Browser" />
              </div>
              <div className="download-text">
                Download the native app for <br></br>
                <span>Windows</span>
              </div>
            </div>
            <div className="right-aligned">
              <Button
                className="download-button"
                variant="secondary"
                onClick={() => {
                  window.open(LINKS.WINDOWS, "_blank");
                }}
                label="Download"
              />
            </div>
          </div>
        )}
        {ShowChromeInstall() && (
          <div className="download-option">
            <div className="left-aligned">
              <div className="download-icon">
                <img src={ChromeLogo} alt="Web Browser" />
              </div>
              <div className="download-text">
                Install the extension for <br></br>
                <span>Chrome</span>
              </div>
            </div>
            <div className="right-aligned">
              <Button
                className="download-button"
                variant="secondary"
                onClick={() => {
                  window.open(LINKS.CHROME_EXTENSION, "_blank");
                }}
                label="Install"
              />
            </div>
          </div>
        )}
        {ShowEdgeInstall() && (
          <div className="download-option">
            <div className="left-aligned">
              <div className="download-icon">
                <img src={EdgeLogo} alt="Web Browser" />
              </div>
              <div className="download-text">
                Install the extension for <br></br>
                <span>Microsoft Edge</span>
              </div>
            </div>
            <div className="right-aligned">
              <Button
                className="download-button"
                variant="secondary"
                onClick={() => {
                  window.open(LINKS.CHROME_EXTENSION, "_blank");
                }}
                label="Install"
              />
            </div>
          </div>
        )}
        <div className="skip-for-now">
          <div className="also-available">
            {UserAgent === "mac" && (
              <>
                Available for MacOS, Windows, Google Chrome, Microsoft Edge, iOS
                and Android
              </>
            )}
            {UserAgent === "windows" && (
              <>
                Also available for MacOS, Google Chrome, Microsoft Edge, iOS and
                Android
              </>
            )}
            {(UserAgent === "linux" || UserAgent === "android") && (
              <>
                Available for MacOS, Windows, Google Chrome, Microsoft Edge, iOS
                and Android
              </>
            )}
          </div>
          <div
            className="skip-text"
            onClick={() => {
              window.location.href = `${LINKS.DASHBOARD}/auth?accessToken=${AccessToken}&jwtToken=${JwtToken}`;
            }}
          >
            Skip for now
          </div>
        </div>
      </div>
    </div>
  );
};
